import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS, STALE_TIME } from '@/constants';
import productService from '@/services/product.service';

type UseAdminProductContextOptions = {
  enabled?: boolean;
};

export const useAdminProductContext = (options?: UseAdminProductContextOptions) => {
  const { enabled = true } = options ?? {};

  return useQuery({
    queryKey: [QUERY_KEYS.ADMIN_PRODUCT_CONTEXT],
    queryFn: () => productService.getAdminProductContext(),
    staleTime: STALE_TIME,
    enabled,
  });
};
